module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-property-cluster-pin-ff7b6f37073d2854c3e75b8f9bf03acc.svg";